// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__knWg6","list":"BalanceDue_list__1rCac","listRow":"BalanceDue_listRow__21Pqt","total":"BalanceDue_total__1iQFr"};